module.exports = __webpack_public_path__ + "static/jacky-7bfe9b01aa4949a1709ef053a007ee30.png";